import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Booking } from '../../../core/models/booking.model';

@Component({
  selector: 'app-booking-delete-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './booking-delete-dialog.component.html',
  styleUrl: './booking-delete-dialog.component.scss',
})
export class BookingDeleteDialogComponent {
  readonly data = inject<{ booking: Booking }>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<BookingDeleteDialogComponent, boolean>>(MatDialogRef);
}
